import ViewDealerVlansComponent from "../components/admin/ViewDealerVlans";

const DealerVlansPage = () => {
  return (
    <>
      <ViewDealerVlansComponent />
    </>
  );
};
export default DealerVlansPage;
